import HTMLtoDOCX from "@turbodocx/html-to-docx"

export const buildDocx = async ({ html, filename, font, defaultFontSize, pageNumbers, margins }) => {
  const blob = await HTMLtoDOCX(
    html,
    null,
    {
      table: { row: { cantSplit: true } },
      pageNumber: pageNumbers || false,
      lang: 'cs-CZ',
      font: font || 'Times New Roman',
      fontSize: defaultFontSize || 22, // HIP = 11pt
      margins: { top: 1440, right: 1600, bottom: 1240, left: 1600, ...(margins || {}) },
    },
    null,
  );
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
